export const headerDataAssignment = {
    title: 'Etat RH',
    submodules: [
        createData(0, "Historique du personnel", "/assignment"),
        createData(1, "Historique de sortie de la personne", "/suivisortie"),
        createData(2, "Historique des congés sans solde et congés de maternité", "/suivisanssolde"),
        createData(3, "Historique des affectations", "/suiviassignement"),
        createData(3, "Historique de la répartition du personnel par financement", "/suivifunding"),
    ],
}

function createData(id, moduleName, ref) {
    return { id, moduleName, ref};
}